module.exports = __webpack_public_path__ + "assets/img/图标／68px@2x(3).3427f737.png";